module.exports = __webpack_public_path__ + "img/trash.dc15c565.svg";